"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerAll = exports.tryFindByCode = exports.find = exports.register = exports.EVoyageCarryableType = void 0;
var angleUtil_sidecar_1 = require("@lib/angleUtil-sidecar");
var imports_1 = require("@lib/imports");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var EVoyageCarryableType;
(function (EVoyageCarryableType) {
    EVoyageCarryableType[EVoyageCarryableType["Default"] = -1] = "Default";
    EVoyageCarryableType[EVoyageCarryableType["Null"] = 0] = "Null";
    EVoyageCarryableType[EVoyageCarryableType["Coffee"] = 1] = "Coffee";
    EVoyageCarryableType[EVoyageCarryableType["BattleRifle"] = 2] = "BattleRifle";
    EVoyageCarryableType[EVoyageCarryableType["Mop"] = 3] = "Mop";
    EVoyageCarryableType[EVoyageCarryableType["Extinguisher"] = 4] = "Extinguisher";
    EVoyageCarryableType[EVoyageCarryableType["Wrench"] = 5] = "Wrench";
    EVoyageCarryableType[EVoyageCarryableType["Medpack"] = 6] = "Medpack";
    EVoyageCarryableType[EVoyageCarryableType["Torpedo"] = 7] = "Torpedo";
    EVoyageCarryableType[EVoyageCarryableType["AlienCorpse"] = 8] = "AlienCorpse";
    EVoyageCarryableType[EVoyageCarryableType["CrewCorpse"] = 9] = "CrewCorpse";
    EVoyageCarryableType[EVoyageCarryableType["Firebomb"] = 10] = "Firebomb";
    EVoyageCarryableType[EVoyageCarryableType["Breachbomb"] = 11] = "Breachbomb";
})(EVoyageCarryableType = exports.EVoyageCarryableType || (exports.EVoyageCarryableType = {}));
var _default = {
    code: 'default',
    name: 'Default',
    frame: sprites_sidecar_1.sprites.voyTileCheckerFine1[0],
    frames: [],
    type: EVoyageCarryableType.Default,
    info: 'Default',
    rackOx: 0,
    rackOy: 0,
    carryScaleX: 1,
    carryOx: 8,
    carryOy: 0,
    scale: 2,
    tint: 0xffffff,
    rotation: 0,
};
var dataList = [];
function register(data) {
    var d = Object.assign({}, _default, data);
    dataList.push(d);
    return d;
}
exports.register = register;
function find(type) {
    return imports_1.l.find(dataList, function (c) { return c.type === type; });
}
exports.find = find;
function tryFindByCode(code) {
    return imports_1.l.find(dataList, function (c) { return code.startsWith(c.code); }) || null;
}
exports.tryFindByCode = tryFindByCode;
function registerAll() {
    register({
        type: EVoyageCarryableType.Null,
        frame: sprites_sidecar_1.sprites.voyTileCheckerFine2[0],
        name: 'Null',
        code: 'null',
    });
    register({
        type: EVoyageCarryableType.Coffee,
        // frame: sprites.voyItemCoffee[0],
        frame: sprites_sidecar_1.sprites.voyInkItemCoffee[0],
        name: 'Coffee',
        code: 'coffee',
        info: 'Speeds you up!',
        scale: 0.3,
        carryScaleX: -1,
        carryOx: 8,
        carryOy: 2,
    });
    register({
        type: EVoyageCarryableType.BattleRifle,
        // frame: sprites.voyItemBattleRifle[0],
        frame: sprites_sidecar_1.sprites.voyInkItemBattlerifle[0],
        name: 'Battle Rifle',
        code: 'br',
        info: 'Battle Rifles - for when you want aliens dead faster (TM)',
        scale: 0.3,
        rackOx: 0,
        rackOy: 0,
        carryOx: 10,
    });
    register({
        type: EVoyageCarryableType.Mop,
        // frame: sprites.voyItemMop[0],
        frame: sprites_sidecar_1.sprites.voyInkItemMop[0],
        name: 'Mop',
        code: 'mop',
        info: 'Clean up splatters and spilled coffee',
        scale: 0.3,
        rackOy: -2,
        carryOx: 14,
    });
    register({
        type: EVoyageCarryableType.Wrench,
        // frame: sprites.voyItemWrench[0],
        frame: sprites_sidecar_1.sprites.voyInkItemWrench2[0],
        name: 'Wrench',
        code: 'wr',
        info: 'Fix things faster',
        scale: 0.3,
    });
    register({
        type: EVoyageCarryableType.Medpack,
        //frame: sprites.voyItemMedpack[0],
        frame: sprites_sidecar_1.sprites.voyInkItemMedpack[0],
        name: 'Medpack',
        code: 'med',
        info: 'Heal nearby crew',
        scale: 0.3,
        rackOx: 1,
        rackOy: -1,
    });
    register({
        type: EVoyageCarryableType.Extinguisher,
        // frame: sprites.voyItemExtinguisher[0],
        frame: sprites_sidecar_1.sprites.voyInkItemExtinguisher[0],
        name: 'Fire Extinguisher',
        code: 'ext',
        info: 'Extinguishes fires',
        rackOx: -2,
        scale: 0.3,
        carryOx: 12,
    });
    register({
        type: EVoyageCarryableType.Torpedo,
        // frame: sprites.voyItemTorpedo[0],
        frame: sprites_sidecar_1.sprites.voyInkItemTorpedo[0],
        name: 'Torpedo',
        code: 'torp',
        info: 'Load into torpedo tube. Smells like potatoes',
        scale: 0.3,
        rackOx: -4,
    });
    register({
        type: EVoyageCarryableType.AlienCorpse,
        // frame: sprites.voyTileCrew[0],
        frame: sprites_sidecar_1.sprites.voyInkMonsterAlien[0],
        name: 'Alien coprse',
        code: 'corpse-a',
        info: 'A dead alien',
        rackOx: 0,
        carryOx: 6,
        scale: 0.25,
        rotation: angleUtil_sidecar_1.angleUtil.turn * 0.25,
        tint: voyageColors_sidecar_1.voyageColors.greenDull,
    });
    register({
        type: EVoyageCarryableType.CrewCorpse,
        frame: sprites_sidecar_1.sprites.voyTileCrew[0],
        name: 'Crew coprse',
        code: 'corpse-c',
        info: 'A dead crewmember',
        rackOx: 0,
        carryOx: 6,
    });
    register({
        type: EVoyageCarryableType.Firebomb,
        // frame: sprites.voyItemBomb[0],
        frame: sprites_sidecar_1.sprites.voyInkItemBomb1[0],
        frames: [sprites_sidecar_1.sprites.voyInkItemBomb1[0], sprites_sidecar_1.sprites.voyInkItemBomb2[0]],
        name: 'Firebomb',
        code: 'firebomb',
        info: 'A firebomb',
        rackOx: 0,
        carryOx: 6,
        scale: 0.3,
        tint: voyageColors_sidecar_1.voyageColors.yellow,
    });
    register({
        type: EVoyageCarryableType.Breachbomb,
        frame: sprites_sidecar_1.sprites.voyInkItemBomb2[0],
        frames: [sprites_sidecar_1.sprites.voyInkItemBomb1[0], sprites_sidecar_1.sprites.voyInkItemBomb2[0]],
        name: 'Breachbomb',
        code: 'breachbomb',
        info: 'A breachbomb',
        rackOx: 0,
        carryOx: 6,
        scale: 0.3,
        tint: voyageColors_sidecar_1.voyageColors.red,
    });
    // register({
    //   type: EVoyageCarryableType.Suit,
    //   frame: sprites.voyItemExtinguisher[0],
    //   name: 'Suit',
    //   code: 'suit',
    // })
}
exports.registerAll = registerAll;
